import {toggleGenericFeaturePath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'

export function useToggleFeaturePreview(featureName: string) {
  const {repository} = useLayoutRouteData()

  const toggleFeature = async () => {
    const formData = new FormData()
    formData.append('feature_name', featureName)

    await verifiedFetch(toggleGenericFeaturePath({repo: repository}), {
      body: formData,
      method: 'POST',
    })
  }

  return toggleFeature
}
